import LendioBootstrapTooltip from "~/components/bootstrap/LendioBootstrapTooltip";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('LendioBootstrapTooltip', LendioBootstrapTooltip)
})
